import isNil from 'lodash/isNil';
import get from 'lodash/get';
import debounce from 'lodash/debounce';

const testMode = process.env.REACT_APP_SEND_GOOGLE_EVENTS === '1';
const testPrefix = testMode ? 'test_' : '';
const isProd = window.location.hostname === 'app.searchlight.ai';

function allowEvent() {
  if (
    // If you're on production
    (isProd &&
      // ...and you didn't takeover an account
      (isNil(localStorage.getItem('adminUserId')) || localStorage.getItem('adminUserId') === '')) ||
    // OR you're in test mode
    testMode
  ) {
    // Create Google Analytics event
    return true;
  }
  return false;
}
/*
 ** analytics.page([category], [name], [properties], [options], [callback]);
 */
// Not in use yet but leaving for now
export const pageView = type => {
  if (allowEvent()) {
    type = testPrefix + type;
    window.analytics.page(type);
  }
};
/*
 **  analytics.track(event, [properties], [options], [callback]);
 */
export const trackEvent = (action, category = 'Misc.') => {
  // Prevents off-production events and takeovers unless specified
  if (allowEvent()) {
    const user = typeof window.analytics.user === 'function' && window.analytics.user();
    const traits = user ? user.traits() : {};
    action = testPrefix + action;
    window.analytics.track(action, {
      category,
      companyId: get(traits, 'company.id'),
      userId: get(traits, 'userId'),
    });
  }
};

export const debouncedEvent = (eventName, eventType) =>
  debounce(() => {
    trackEvent(eventName, eventType);
  }, 250);
